<script lang="ts">
	import { Input, Text } from '@Shelly/shelly-design-system';
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';

	const dispatch = createEventDispatcher();

	export let sceneIsValid: boolean;
	export let checked: boolean;
	export let value: string;
	export let min: number = 0.5;
	const max: number = 10800;
	let error: string = '';
</script>

<Input
	aria-labelledby="input-l87huz9"
	disabled={!checked}
	label={$format('label_placeholder_transition_duration', {
		default: 'e.g. 10 (in 10 seconds)',
	})}
	type="number"
	size="m"
	class="mt-xs mb-xs"
	tabIndex="-1"
	value={value || ''}
	on:input={(e) => {
		if (+e.target.value >= min && +e.target.value <= max) {
			sceneIsValid = true;
			error = '';
		} else {
			sceneIsValid = false;
			error = $format('error_transition_duration_limits', {
				default: 'The value must be within valid limits.',
			});
		}
		value = e.target.value;
		dispatch('change', { value });
	}}
	{error}
	id="input-l87huz9"
/>
<Text styleType="body-small" class="mb-s text-color-3">
	{$format('min_max_unit_range', {
		values: { min, max },
		default: '(Minimum: {min}, Maximum: {max})',
	})}
</Text>
